import { Controller } from "@hotwired/stimulus"
import mermaid from "mermaid"

export default class extends Controller {
  connect() {
    // Initialize mermaid with configuration
    mermaid.initialize({
      startOnLoad: false,
      theme: 'base',
      securityLevel: 'loose',
      fontFamily: 'ui-sans-serif, system-ui, sans-serif',
      fontSize: 16,
      themeVariables: {
        // Primary colors - using blue tones
        primaryColor: '#E0F2FE',
        primaryTextColor: '#0C4A6E',
        primaryBorderColor: '#0EA5E9',

        // Secondary colors - using slate/gray
        secondaryColor: '#F1F5F9',
        secondaryTextColor: '#334155',
        secondaryBorderColor: '#64748B',

        // Tertiary colors - using emerald for success states
        tertiaryColor: '#D1FAE5',
        tertiaryTextColor: '#065F46',
        tertiaryBorderColor: '#10B981',

        // Notes/highlights - using amber (softer than yellow)
        noteBkgColor: '#FEF3C7',
        noteTextColor: '#78350F',
        noteBorderColor: '#F59E0B',

        // Lines and arrows
        lineColor: '#64748B',

        // Sequence diagram specific
        actorBkg: '#E0F2FE',
        actorBorder: '#0EA5E9',
        actorTextColor: '#0C4A6E',
        activationBkgColor: '#DBEAFE',
        activationBorderColor: '#0EA5E9',

        // Flowchart specific
        mainBkg: '#E0F2FE',
        nodeBorder: '#0EA5E9',
        clusterBkg: '#F8FAFC',
        clusterBorder: '#CBD5E1',

        // Text
        textColor: '#1E293B',
        fontSize: '16px'
      },
      flowchart: {
        curve: 'basis',
        padding: 30,
        nodeSpacing: 100,
        rankSpacing: 80,
        useMaxWidth: true,
        wrappingWidth: 300,
        htmlLabels: true
      },
      sequence: {
        diagramMarginX: 30,
        diagramMarginY: 30,
        actorMargin: 80,
        width: 200,
        height: 65,
        boxMargin: 15,
        boxTextMargin: 8,
        noteMargin: 15,
        messageMargin: 50,
        mirrorActors: true,
        useMaxWidth: true
      }
    })

    // Render all mermaid diagrams
    this.renderDiagrams()
  }

  async renderDiagrams() {
    const diagrams = this.element.querySelectorAll('.mermaid')

    for (const diagram of diagrams) {
      try {
        const { svg } = await mermaid.render(
          `mermaid-${Math.random().toString(36).substr(2, 9)}`,
          diagram.textContent
        )
        diagram.innerHTML = svg

        // Make SVG responsive and full width
        const svgElement = diagram.querySelector('svg')
        if (svgElement) {
          svgElement.style.maxWidth = '100%'
          svgElement.style.height = 'auto'
        }
      } catch (error) {
        console.error('Mermaid rendering error:', error)
        diagram.innerHTML = `<div class="text-red-600 p-4 border border-red-200 rounded">
          Error rendering diagram: ${error.message}
        </div>`
      }
    }
  }
}
